(function () {
  const initSolviNav = (root) => {
    if (!root || root.dataset.solviNavReady === 'true') return;
    root.dataset.solviNavReady = 'true';
        /* ---------------------------------------------
       Mobile quick search
       --------------------------------------------- */

    const mobileSearchMedia = window.matchMedia('(max-width: 989px)');
    const searchTrigger = root.querySelector('.solvi-floating-nav__search');
    const navInner = root.querySelector('.solvi-floating-nav__inner');

    let mobileSearchPanel = root.querySelector('[data-solvi-mobile-search]');
    let mobileSearchInput = null;

    if (searchTrigger && navInner && !mobileSearchPanel) {
      mobileSearchPanel = document.createElement('div');
      mobileSearchPanel.className = 'solvi-mobile-search-panel';
      mobileSearchPanel.dataset.solviMobileSearch = '';
      mobileSearchPanel.setAttribute('aria-hidden', 'true');

      mobileSearchPanel.innerHTML = `
        <form
          class="solvi-mobile-search-form"
          action="/search"
          method="get"
          role="search"
        >
          <button
            class="solvi-mobile-search-submit"
            type="submit"
            aria-label="Search"
          >
            <svg
              viewBox="0 0 24 24"
              aria-hidden="true"
            >
              <circle cx="11" cy="11" r="6.5"></circle>
              <path d="M16 16l4.5 4.5"></path>
            </svg>
          </button>

          <input
            class="solvi-mobile-search-input"
            type="search"
            name="q"
            placeholder="Search scents, brands, notes…"
            autocomplete="off"
            enterkeyhint="search"
            aria-label="Search Solvi"
          >

          <input
            type="hidden"
            name="type"
            value="product"
          >

          <button
            class="solvi-mobile-search-close"
            type="button"
            aria-label="Close search"
            data-solvi-search-close
          >
            ×
          </button>
        </form>
      `;

      navInner.appendChild(mobileSearchPanel);

      mobileSearchInput =
        mobileSearchPanel.querySelector('.solvi-mobile-search-input');

      const searchClose =
        mobileSearchPanel.querySelector('[data-solvi-search-close]');

      searchTrigger.setAttribute('aria-expanded', 'false');
      searchTrigger.setAttribute('aria-controls', 'SolviMobileSearch');

      mobileSearchPanel.id = 'SolviMobileSearch';

      const openMobileSearch = () => {
        if (!mobileSearchMedia.matches) return;

        mobileSearchPanel.classList.add('is-open');
        mobileSearchPanel.setAttribute('aria-hidden', 'false');
        searchTrigger.setAttribute('aria-expanded', 'true');

        window.setTimeout(() => {
          mobileSearchInput?.focus();
        }, 120);
      };

      const closeMobileSearch = () => {
        mobileSearchPanel.classList.remove('is-open');
        mobileSearchPanel.setAttribute('aria-hidden', 'true');
        searchTrigger.setAttribute('aria-expanded', 'false');
      };

      const toggleMobileSearch = (event) => {
        if (!mobileSearchMedia.matches) return;

        event.preventDefault();

        const isOpen =
          mobileSearchPanel.classList.contains('is-open');

        if (isOpen) {
          closeMobileSearch();
        } else {
          openMobileSearch();
        }
      };

      searchTrigger.addEventListener('click', toggleMobileSearch);

      searchClose?.addEventListener('click', () => {
        closeMobileSearch();
        searchTrigger.focus({ preventScroll: true });
      });

      document.addEventListener('click', (event) => {
        if (!mobileSearchMedia.matches) return;

        const clickedSearch =
          mobileSearchPanel.contains(event.target) ||
          searchTrigger.contains(event.target);

        if (!clickedSearch) {
          closeMobileSearch();
        }
      });

      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          closeMobileSearch();
        }
      });

      mobileSearchMedia.addEventListener?.('change', (event) => {
        if (!event.matches) {
          closeMobileSearch();
        }
      });
    }

    const normalizedLabel = (item) => (item?.textContent || '').trim().replace(/\s+/g, ' ').toLowerCase();
    const matchesLabel = (item, label) => normalizedLabel(item)
      .replace(/[\s→⌄▾]+$/g, '') === label.toLowerCase();
    const findLinkByLabel = (label) => Array.from(root.querySelectorAll('a[href]'))
      .find((item) => matchesLabel(item, label));
    const ourStoryLink = findLinkByLabel('about');
    const visitLink = findLinkByLabel('visit solvi');
    const contactLink = findLinkByLabel('contact');
    const aboutUrl = ourStoryLink?.getAttribute('href') || '/pages/about';
    const visitUrl = visitLink?.getAttribute('href') || '/pages/visit-solvi';
    const contactUrl = contactLink?.getAttribute('href') || '/pages/contact';

    const addAboutLinks = (container) => {
      [
        ['Our Story', aboutUrl],
        ['Visit Solvi', visitUrl],
        ['Contact', contactUrl]
      ].forEach(([label, href]) => {
        const item = document.createElement('a');
        item.href = href;
        item.textContent = label;
        container.appendChild(item);
      });
    };

    const aboutChip = Array.from(root.querySelectorAll('.solvi-floating-nav__chip, .solvi-floating-nav__desktop-trigger'))
      .find((item) => matchesLabel(item, 'about'));
    if (aboutChip) {
      const existingWrapper = aboutChip.closest('[data-solvi-nav-item]');
      const wrapper = existingWrapper || document.createElement('div');
      const trigger = aboutChip.matches('button') ? aboutChip : document.createElement('button');
      const existingPanel = wrapper.querySelector('[data-solvi-nav-panel]');
      const panel = existingPanel || document.createElement('div');
      const list = document.createElement('ul');
      const panelId = panel.id || `SolviAboutDropdown-${Math.random().toString(36).slice(2, 9)}`;

      wrapper.classList.add('solvi-floating-nav__desktop-item', 'solvi-floating-nav__desktop-item--about');
      wrapper.dataset.solviNavItem = '';
      trigger.type = 'button';
      trigger.className = `${aboutChip.className} solvi-floating-nav__desktop-trigger`;
      if (trigger !== aboutChip) trigger.innerHTML = aboutChip.innerHTML;
      trigger.setAttribute('aria-expanded', 'false');
      trigger.setAttribute('aria-controls', panelId);
      trigger.dataset.solviNavTrigger = '';
      panel.id = panelId;
      panel.className = 'solvi-floating-nav__dropdown solvi-floating-nav__dropdown--right solvi-floating-nav__dropdown--compact';
      panel.hidden = true;
      panel.dataset.solviNavPanel = '';

      ['Our Story', 'Visit Solvi', 'Contact'].forEach((label, index) => {
        const item = document.createElement('li');
        const link = document.createElement('a');
        link.href = [aboutUrl, visitUrl, contactUrl][index];
        link.textContent = label;
        item.appendChild(link);
        list.appendChild(item);
      });
      panel.replaceChildren(list);
      if (!existingWrapper) {
        aboutChip.parentNode.insertBefore(wrapper, aboutChip);
        aboutChip.remove();
        wrapper.append(trigger, panel);
      } else {
        if (trigger !== aboutChip) aboutChip.replaceWith(trigger);
        if (!existingPanel) wrapper.appendChild(panel);
      }
    }

    const drawerPanelsRoot = root.querySelector('[data-solvi-drawer-panels]');
    const drawerMainPanel = root.querySelector('[data-solvi-drawer-panel="main"]');
    const drawerAboutLink = drawerMainPanel
      ? Array.from(drawerMainPanel.querySelectorAll('a, button')).find((item) => matchesLabel(item, 'about'))
      : null;
    if (drawerPanelsRoot && drawerAboutLink && !root.querySelector('[data-solvi-drawer-panel="about"]')) {
      const aboutButton = document.createElement('button');
      const aboutPanel = document.createElement('div');
      const backButton = document.createElement('button');
      const heading = document.createElement('h2');
      const links = document.createElement('div');

      aboutButton.type = 'button';
      aboutButton.dataset.solviPanelTarget = 'about';
      aboutButton.innerHTML = '<span>About</span><span aria-hidden="true">→</span>';
      drawerAboutLink.replaceWith(aboutButton);

      aboutPanel.className = 'solvi-floating-nav__drawer-panel';
      aboutPanel.dataset.solviDrawerPanel = 'about';
      aboutPanel.setAttribute('aria-hidden', 'true');
      backButton.type = 'button';
      backButton.className = 'solvi-floating-nav__drawer-back';
      backButton.dataset.solviPanelBack = '';
      backButton.textContent = '← menu';
      heading.textContent = 'About';
      links.className = 'solvi-floating-nav__drawer-group';
      addAboutLinks(links);
      aboutPanel.append(backButton, heading, links);
      drawerPanelsRoot.appendChild(aboutPanel);
    }

    const currentPath = window.location.pathname.replace(/\/$/, '') || '/';
    root.querySelectorAll('.solvi-floating-nav__drawer a[href]').forEach((link) => {
      const linkPath = new URL(link.href, window.location.origin).pathname.replace(/\/$/, '') || '/';
      if (linkPath === currentPath) link.setAttribute('aria-current', 'page');
    });

    const dropdownItems = Array.from(root.querySelectorAll('[data-solvi-nav-item]'));
    const drawer = root.querySelector('[data-solvi-drawer]');
    const drawerOpen = root.querySelector('[data-solvi-drawer-open]');
    const drawerCloseButtons = Array.from(root.querySelectorAll('[data-solvi-drawer-close]'));
    const drawerPanels = root.querySelector('[data-solvi-drawer-panels]');
    const drawerPanelList = Array.from(root.querySelectorAll('[data-solvi-drawer-panel]'));
    const panelTargets = Array.from(root.querySelectorAll('[data-solvi-panel-target]'));
    const panelBackButtons = Array.from(root.querySelectorAll('[data-solvi-panel-back]'));
    const hoverMedia = window.matchMedia('(hover: hover) and (pointer: fine)');
    let drawerReturnFocus = null;
    let closeTimer = null;

    drawerPanelList.forEach((panel, index) => {
      panel.dataset.solviDrawerPanelIndex = String(index);
    });

    const focusableSelector = [
      'a[href]',
      'button:not([disabled])',
      'input:not([disabled])',
      'select:not([disabled])',
      'textarea:not([disabled])',
      '[tabindex]:not([tabindex="-1"])'
    ].join(',');

    const closeDropdowns = (exceptItem) => {
      dropdownItems.forEach((item) => {
        if (exceptItem && item === exceptItem) return;
        const trigger = item.querySelector('[data-solvi-nav-trigger]');
        const panel = item.querySelector('[data-solvi-nav-panel]');
        if (!trigger || !panel) return;
        trigger.setAttribute('aria-expanded', 'false');
        panel.hidden = true;
      });
    };

    const openDropdown = (item) => {
      const trigger = item.querySelector('[data-solvi-nav-trigger]');
      const panel = item.querySelector('[data-solvi-nav-panel]');
      if (!trigger || !panel) return;
      closeDropdowns(item);
      trigger.setAttribute('aria-expanded', 'true');
      panel.hidden = false;
    };

    dropdownItems.forEach((item) => {
      const trigger = item.querySelector('[data-solvi-nav-trigger]');
      const panel = item.querySelector('[data-solvi-nav-panel]');
      if (!trigger || !panel) return;

      trigger.addEventListener('click', () => {
        const isOpen = trigger.getAttribute('aria-expanded') === 'true';
        if (isOpen) {
          closeDropdowns();
        } else {
          openDropdown(item);
        }
      });

      item.addEventListener('mouseenter', () => {
        if (!hoverMedia.matches) return;
        window.clearTimeout(closeTimer);
        openDropdown(item);
      });

      item.addEventListener('mouseleave', () => {
        if (!hoverMedia.matches) return;
        closeTimer = window.setTimeout(() => {
          if (!item.matches(':focus-within')) closeDropdowns();
        }, 120);
      });

      item.addEventListener('focusin', () => openDropdown(item));
      item.addEventListener('focusout', () => {
        window.setTimeout(() => {
          if (!item.matches(':focus-within')) closeDropdowns();
        }, 0);
      });
    });

    document.addEventListener('click', (event) => {
      if (!root.contains(event.target)) closeDropdowns();
    });

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      closeDropdowns();
      if (drawer && drawer.getAttribute('aria-hidden') === 'false') closeDrawer();
    });

    const setDrawerPanel = (panelName) => {
      const panel = drawerPanelList.find((item) => item.dataset.solviDrawerPanel === panelName);
      if (!panel || !drawerPanels) return;

      const index = Number(panel.dataset.solviDrawerPanelIndex || 0);
      drawerPanels.style.setProperty('--solvi-drawer-panel-index', index);
      drawerPanelList.forEach((item) => {
        const isActive = item === panel;
        item.setAttribute('aria-hidden', isActive ? 'false' : 'true');
      });

      const firstFocusable = panel.querySelector(focusableSelector);
      if (firstFocusable) firstFocusable.focus({ preventScroll: true });
    };

    const openDrawer = () => {
      if (!drawer || !drawerOpen) return;
      drawerReturnFocus = document.activeElement;
      drawer.hidden = false;
      drawer.setAttribute('aria-hidden', 'false');
      drawerOpen.setAttribute('aria-expanded', 'true');
      document.body.classList.add('solvi-nav-drawer-open');
      drawerCloseButtons.forEach((button) => {
        if (button.classList.contains('solvi-floating-nav__drawer-backdrop')) {
          button.hidden = false;
        }
      });
      setDrawerPanel('main');
    };

    function closeDrawer() {
      if (!drawer || !drawerOpen) return;
      drawer.setAttribute('aria-hidden', 'true');
      drawerOpen.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('solvi-nav-drawer-open');
      drawerCloseButtons.forEach((button) => {
        if (button.classList.contains('solvi-floating-nav__drawer-backdrop')) {
          button.hidden = true;
        }
      });
      window.setTimeout(() => setDrawerPanel('main'), 180);
      if (drawerReturnFocus && typeof drawerReturnFocus.focus === 'function') {
        drawerReturnFocus.focus({ preventScroll: true });
      }
    }

    drawerOpen?.addEventListener('click', openDrawer);
    drawerCloseButtons.forEach((button) => button.addEventListener('click', closeDrawer));
    panelTargets.forEach((button) => {
      button.addEventListener('click', () => setDrawerPanel(button.dataset.solviPanelTarget));
    });
    panelBackButtons.forEach((button) => {
      button.addEventListener('click', () => setDrawerPanel('main'));
    });

    drawer?.addEventListener('keydown', (event) => {
      if (event.key !== 'Tab') return;
      const focusable = Array.from(drawer.querySelectorAll(focusableSelector)).filter((item) => {
        const panel = item.closest('[data-solvi-drawer-panel]');
        return !panel || panel.getAttribute('aria-hidden') !== 'true';
      });
      if (!focusable.length) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });
  };

  const initAll = () => {
    document.querySelectorAll('[data-solvi-floating-nav]').forEach(initSolviNav);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('[data-solvi-floating-nav]').forEach(initSolviNav);
  });
})();
